import '../main'
import swipeCell from './src/swipeCell.vue'

swipeCell.install = function (Vue) {
    Vue.component(swipeCell.name, swipeCell)
}

export default swipeCell


// WEBPACK FOOTER //
// ./src/components/swipeCell/index.js